/** 與後端 STANDARD_DISPLAY_NAMES / compliance_summary.standards 鍵名一致 */
export const AWS_CIS_FOUNDATIONS_V3 = 'CIS AWS Foundations Benchmark v3.0.0';
export const AWS_FSBP_V1 = 'AWS Foundational Security Best Practices v1.0.0';
